import "./App.css";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import RouterComponent from "./Router/RouterComponent";
import React, { FC } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter } from "react-router-dom";
import { tr } from "date-fns/locale/tr";

const App: FC = () => {
  return (
    <div className="App">
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
        <BrowserRouter>
          <RouterComponent />
        </BrowserRouter>
      </LocalizationProvider>
    </div>
  );
};

export default App;
